export default __webpack_public_path__ + "static/media/fingerprint.9389b449.gif";